























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import CSVImporter from '@ui/POI/CSVImporter'
import POILocationCSVImportTrigger from './POILocationCSVImportTrigger.coffee'

settings =
  name: 'POILocationCSVImportTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LoadingIndicator, CSVImporter }
    mixins: [POILocationCSVImportTrigger.trigger()]

    data: ->
      type: 'paste'
      file: null
      sheetLinks:
        [
          '1VZDCmEJ_1awAxjA6MM1C6qi1FzmDI0s5AryxR-r3kg0/edit#gid=0',
          '1VZDCmEJ_1awAxjA6MM1C6qi1FzmDI0s5AryxR-r3kg0/edit#gid=1903192301'
        ]

    computed:
      hasCSV: -> @modal.data?.csv_string?.length || @modal.data?.google_sheet_url?.length
      CSVFileUploadPath: -> "#{process.env.VUE_APP_API_ENDPOINT}/uploads/campaigns/#{@modal.config.campaign?.id}/pois"

    methods:
      modalData: -> { csv_string: '', google_sheet_url: '' }

export default VueOptions.vue settings
